/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Xrisk_C2aInputs */

const en_home_xrisk_c2a = /** @type {(inputs: Home_Xrisk_C2aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How and why AI could kill us`)
};

/**
* | output |
* | --- |
* | "How and why AI could kill us" |
*
* @param {Home_Xrisk_C2aInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_xrisk_c2a = /** @type {((inputs?: Home_Xrisk_C2aInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Xrisk_C2aInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_xrisk_c2a(inputs)
});